import { Box, Button, Flex, Header } from '@driftt/dds'
import { Subnav as SideNav } from '@driftt/tide-subnav'
import React, { useCallback, useState } from 'react'
import { NavLink } from 'react-router-dom'

import usePageTitle from 'hooks/usePageTitle'
import { getSubNavNodes } from 'utils/getSubNavNodes'

import VariablesList from '../../components/GlobalComponents/VariablesList'

const GlobalComponentLibrary = () => {
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false)
  const SUB_NAV_NODES = getSubNavNodes()

  usePageTitle('Drift | Global components')

  const [createVariableModalOpen, toggleCreateVariableModal] = useState(false)

  const callbackVariableModal = useCallback(
    (toggle) => toggleCreateVariableModal(toggle),
    []
  )
  return (
    <Box css={{ width: '100%', height: '100%' }}>
      <Flex direction="row" fullWidth fullHeight gap={0}>
        <SideNav
          open={sidebarIsOpen}
          nodes={SUB_NAV_NODES}
          title="Playbooks"
          NavLink={NavLink}
          style={{ height: '100%' }}
          onToggle={() => setSidebarIsOpen(!sidebarIsOpen)}
        />
        <Flex direction="column" gap={0} fullWidth fullHeight>
          <Flex direction="column" gap={0} css={{ padding: '$2 $6' }} fullWidth>
            <Flex
              direction="row"
              fullWidth
              gap={0}
              alignItems="center"
              justifyContent="space-between"
            >
              <Header>Content variables</Header>
              <Box>
                <Button onClick={() => callbackVariableModal(true)}>
                  Create variable
                </Button>
              </Box>
            </Flex>
          </Flex>
          <Flex
            fullHeight
            fullWidth
            direction="column"
            gap={3}
            css={{
              background: '$gray2',
              padding: '$2 $4',
              overflow: 'auto',
            }}
          >
            <VariablesList
              createVariableModalOpen={createVariableModalOpen}
              toggleCreateVariableModal={callbackVariableModal}
            />
          </Flex>
        </Flex>
      </Flex>
    </Box>
  )
}

export default GlobalComponentLibrary
